/* jscs:disable maximumNumberOfLines */
'use strict';

angular.module('AcaApp').controller('FormController', [
  '$scope',
  '$mdDialog',
  '$timeout',
  '$rootScope',
  'DROP_DOWNS',
  'FORM_MESSAGES',
  'EXCEPTION',
  'ParticipantService',
  'EmployerService',
  'FormService',
  'ShortcutsService',
  'DependentService',
  'currentForm',
  'LayoutService',
  'UtilsService',
  '$window',
  /* jscs:disable maximumLineLength */
  function($scope, $mdDialog, $timeout, $rootScope, DROP_DOWNS, FORM_MESSAGES, EXCEPTION, ParticipantService, EmployerService, FormService, ShortcutsService, DependentService, currentForm, LayoutService, UtilsService, $window){
    ShortcutsService.disableBackSpaceDefault();
    $scope.searchCriteria = {};
    $scope.searchCriteria.type = 'tin';
    $scope.searchCriteria.text = 'Tin';
    $scope.searchCriteria.minLength = '9';
    $scope.coverageCodes = DROP_DOWNS[UtilsService.getTaxYear()].CoverageCodes;
    $scope.harborCodes = DROP_DOWNS[UtilsService.getTaxYear()].HarborCodes;
    $scope.originOfPolicies = DROP_DOWNS[UtilsService.getTaxYear()].originOfPolicy;
    $scope.planStartMonths = DROP_DOWNS[UtilsService.getTaxYear()].PlanStartMonth;
    $scope.selectedItem = {};
    $scope.validationFlagForm = false;
    $scope.validationsBE = false;
    $scope.formChanged = false;
    $scope.taxyear = $window.sessionStorage.taxYear;
    if(currentForm !== undefined) {
      $scope.formAction = 'edit';
      $scope.form = currentForm.Forms1095C ? currentForm.Forms1095C : currentForm.Forms1095B;
      $scope.form.disabled = true;
      $scope.monthly = {value: 'false'};
      $scope.selectedItem.tin = $scope.form.tin;
      if($scope.form.warnings !== undefined){
        if($scope.form.warnings !== ''){
          $scope.validationMessage = UtilsService.errorMessageValidationForString($scope.form.warnings);
          $scope.validationsBE = true;
        }
      }
    }
    else{
      $scope.formAction = 'add';
      $scope.monthly = {value: 'true'};
      $scope.form = {};
      if($scope.formOrigin === 'main'){
        $scope.form.tin = $scope.currentParticipant.tin;
        $scope.selectedItem.tin= $scope.currentParticipant.tin;
      }
    }

    var _formChanged = function(newValue, oldValue){
      if(newValue !== oldValue){
        $scope.formChanged = true;
      }
    };

    $scope.$watch('form', _formChanged, true);
    $scope.$watch('model', _formChanged, true);
    $scope.model = {};
    $scope.rpcForm1095CSubscriber = {};
    $scope.rpcForm1095BSubscriber = {};
    $scope.$DependentService = DependentService;
    $scope.hideDependent = true;
    var setValueIndicator = function(value){
      if(value === '1'){
        $scope.hideDependent = false;
        return true;
      }
      else{
        return false;
      }
    };
    if($scope.formAction === 'edit'){
      $scope.model.jan = setValueIndicator($scope.form.janindicator);
      $scope.model.feb = setValueIndicator($scope.form.febindicator);
      $scope.model.mar = setValueIndicator($scope.form.marindicator);
      $scope.model.apr = setValueIndicator($scope.form.aprindicator);
      $scope.model.may = setValueIndicator($scope.form.mayindicator);
      $scope.model.jun = setValueIndicator($scope.form.junindicator);
      $scope.model.jul = setValueIndicator($scope.form.julindicator);
      $scope.model.aug = setValueIndicator($scope.form.augindicator);
      $scope.model.sep = setValueIndicator($scope.form.sepindicator);
      $scope.model.oct = setValueIndicator($scope.form.octindicator);
      $scope.model.nov = setValueIndicator($scope.form.novindicator);
      $scope.model.dec = setValueIndicator($scope.form.decindicator);
      $scope.model.all = $scope.$DependentService.isAllMonthSelected($scope.model);
    }

    EmployerService.getPayerList().then(function(data){
      $scope.payers = data.result;
      if($scope.form.ptin || $scope.form.employersponsor){
        $timeout(
          function(){
            LayoutService.triggerSelectBoxChange();
            $scope.formChanged = false;
          }
        );
      }
    },
    function(error){
      /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
      $scope.errorMessage = (error.data.error.frontend_message || undefined);
    });
   
    LayoutService.addDatepicker('#empbirthdate');
    $scope.form.empbirthdate = function(date){
      return (date !== undefined) ? UtilsService.getUnixTimestamp(date).split(' ')[0] : '';
    }($scope.form.empbirthdate);

    $scope.closeModal = function(){
      $scope.validationFlagForm = false;
      ShortcutsService.enableBackSpaceDefault();
      $mdDialog.hide();
    };

    $scope.showCovIndividual = function(){
      $scope.hideDependent = false;
    };

    $scope.hideCovIndividual = function(){
      $scope.hideDependent = true;
      $scope.model.all = false;
      $scope.$DependentService.allMonth($scope.model);
    };

    $scope.addCoverageMonths = function(rpcForm1095CSubscriber){
      rpcForm1095CSubscriber.janindicator = (DependentService.getindicatorRPCValue($scope.model.jan) !== '') ? DependentService.getindicatorRPCValue($scope.model.jan) : '';
      rpcForm1095CSubscriber.febindicator = (DependentService.getindicatorRPCValue($scope.model.feb) !== '') ? DependentService.getindicatorRPCValue($scope.model.feb) : '';
      rpcForm1095CSubscriber.marindicator = (DependentService.getindicatorRPCValue($scope.model.mar) !== '') ? DependentService.getindicatorRPCValue($scope.model.mar) : '';
      rpcForm1095CSubscriber.aprindicator = (DependentService.getindicatorRPCValue($scope.model.apr) !== '') ? DependentService.getindicatorRPCValue($scope.model.apr) : '';
      rpcForm1095CSubscriber.mayindicator = (DependentService.getindicatorRPCValue($scope.model.may) !== '') ? DependentService.getindicatorRPCValue($scope.model.may) : '';
      rpcForm1095CSubscriber.junindicator = (DependentService.getindicatorRPCValue($scope.model.jun) !== '') ? DependentService.getindicatorRPCValue($scope.model.jun) : '';
      rpcForm1095CSubscriber.julindicator = (DependentService.getindicatorRPCValue($scope.model.jul) !== '') ? DependentService.getindicatorRPCValue($scope.model.jul) : '';
      rpcForm1095CSubscriber.augindicator = (DependentService.getindicatorRPCValue($scope.model.aug) !== '') ? DependentService.getindicatorRPCValue($scope.model.aug) : '';
      rpcForm1095CSubscriber.sepindicator = (DependentService.getindicatorRPCValue($scope.model.sep) !== '') ? DependentService.getindicatorRPCValue($scope.model.sep) : '';
      rpcForm1095CSubscriber.octindicator = (DependentService.getindicatorRPCValue($scope.model.oct) !== '') ? DependentService.getindicatorRPCValue($scope.model.oct) : '';
      rpcForm1095CSubscriber.novindicator = (DependentService.getindicatorRPCValue($scope.model.nov) !== '') ? DependentService.getindicatorRPCValue($scope.model.nov) : '';
      rpcForm1095CSubscriber.decindicator = (DependentService.getindicatorRPCValue($scope.model.dec) !== '') ? DependentService.getindicatorRPCValue($scope.model.dec) : '';
      return rpcForm1095CSubscriber;
    };

    $scope.validateMandatory = function(){
      if(!$scope.selectedItem || !$scope.form.ptin){
        $scope.errorMessage = FORM_MESSAGES.REQUIRED;
        return true;
      }
      else{
        $scope.errorMessage = '';
        return false;
      }
    };
    $scope.validateFields = function(form){
      if(!form.$valid || !$scope.selectedItem) {
        $scope.incompleteMessage = FORM_MESSAGES.INCOMPLETE;
      }
      else{
        $scope.incompleteMessage = '';
      }
    };

    $scope.cleanCoverageMonthFields = function(){
      $scope.incompleteMessage = FORM_MESSAGES.INCOMPLETE;
    };

    var addZipCodes = function(){
      if($scope.monthly.value === 'false') {
        $scope.rpcForm1095CSubscriber = $scope.form;
        $scope.rpcForm1095CSubscriber.janzipcode= ($scope.form.janzipcode !== undefined) ? $scope.form.janzipcode : '';
        $scope.rpcForm1095CSubscriber.febzipcode= ($scope.form.febzipcode !== undefined) ? $scope.form.febzipcode : '';
        $scope.rpcForm1095CSubscriber.marzipcode= ($scope.form.marzipcode !== undefined) ? $scope.form.marzipcode : '';
        $scope.rpcForm1095CSubscriber.aprzipcode= ($scope.form.aprzipcode !== undefined) ? $scope.form.aprzipcode : '';
        $scope.rpcForm1095CSubscriber.mayzipcode= ($scope.form.mayzipcode !== undefined) ? $scope.form.mayzipcode : '';
        $scope.rpcForm1095CSubscriber.junzipcode= ($scope.form.junzipcode !== undefined) ? $scope.form.junzipcode : '';
        $scope.rpcForm1095CSubscriber.julzipcode= ($scope.form.julzipcode !== undefined) ? $scope.form.julzipcode : '';
        $scope.rpcForm1095CSubscriber.augzipcode= ($scope.form.augzipcode !== undefined) ? $scope.form.augzipcode : '';
        $scope.rpcForm1095CSubscriber.sepzipcode= ($scope.form.sepzipcode !== undefined) ? $scope.form.sepzipcode : '';
        $scope.rpcForm1095CSubscriber.octzipcode= ($scope.form.octzipcode !== undefined) ? $scope.form.octzipcode : '';
        $scope.rpcForm1095CSubscriber.novzipcode= ($scope.form.novzipcode !== undefined) ? $scope.form.novzipcode : '';
        $scope.rpcForm1095CSubscriber.deczipcode= ($scope.form.deczipcode !== undefined) ? $scope.form.deczipcode : '';
      }
      else{
        $scope.form.allmonthszipcode = ($scope.form.allmonthszipcode !== undefined) ? $scope.form.allmonthszipcode : '';
        $scope.rpcForm1095CSubscriber.janzipcode= $scope.form.allmonthszipcode;
        $scope.rpcForm1095CSubscriber.febzipcode= $scope.form.allmonthszipcode;
        $scope.rpcForm1095CSubscriber.marzipcode= $scope.form.allmonthszipcode;
        $scope.rpcForm1095CSubscriber.aprzipcode= $scope.form.allmonthszipcode;
        $scope.rpcForm1095CSubscriber.mayzipcode= $scope.form.allmonthszipcode;
        $scope.rpcForm1095CSubscriber.junzipcode= $scope.form.allmonthszipcode;
        $scope.rpcForm1095CSubscriber.julzipcode= $scope.form.allmonthszipcode;
        $scope.rpcForm1095CSubscriber.augzipcode= $scope.form.allmonthszipcode;
        $scope.rpcForm1095CSubscriber.sepzipcode= $scope.form.allmonthszipcode;
        $scope.rpcForm1095CSubscriber.octzipcode= $scope.form.allmonthszipcode;
        $scope.rpcForm1095CSubscriber.novzipcode= $scope.form.allmonthszipcode;
        $scope.rpcForm1095CSubscriber.deczipcode= $scope.form.allmonthszipcode;
      }
    };

    var addPart1 = function(){
      $scope.rpcForm1095CSubscriber.tin = $scope.selectedItem.tin;
      $scope.rpcForm1095CSubscriber.accountno = $scope.selectedItem.accountno;
      $scope.rpcForm1095CSubscriber.ptin = $scope.form.ptin;
    };

    var addSubscriberMonthlyOffer = function(){
      if($scope.monthly.value === 'false') {
        $scope.rpcForm1095CSubscriber = $scope.form;
        $scope.rpcForm1095CSubscriber.janoffercovercode= ($scope.form.janoffercovercode !== undefined) ? $scope.form.janoffercovercode : '';
        $scope.rpcForm1095CSubscriber.janlowcostmonthprem= ($scope.form.janlowcostmonthprem !== undefined) ? $scope.form.janlowcostmonthprem : '';
        $scope.rpcForm1095CSubscriber.jansafeharborcode= ($scope.form.jansafeharborcode !== undefined) ? $scope.form.jansafeharborcode : '';
        $scope.rpcForm1095CSubscriber.feboffercovercode= ($scope.form.feboffercovercode !== undefined) ? $scope.form.feboffercovercode : '';
        $scope.rpcForm1095CSubscriber.feblowcostmonthprem= ($scope.form.feblowcostmonthprem !== undefined) ? $scope.form.feblowcostmonthprem : '';
        $scope.rpcForm1095CSubscriber.febsafeharborcode= ($scope.form.febsafeharborcode !== undefined) ? $scope.form.febsafeharborcode : '';
        $scope.rpcForm1095CSubscriber.maroffercovercode= ($scope.form.maroffercovercode !== undefined) ? $scope.form.maroffercovercode : '';
        $scope.rpcForm1095CSubscriber.marlowcostmonthprem= ($scope.form.marlowcostmonthprem !== undefined) ? $scope.form.marlowcostmonthprem : '';
        $scope.rpcForm1095CSubscriber.marsafeharborcode= ($scope.form.marsafeharborcode !== undefined) ? $scope.form.marsafeharborcode : '';
        $scope.rpcForm1095CSubscriber.aproffercovercode= ($scope.form.aproffercovercode !== undefined) ? $scope.form.aproffercovercode : '';
        $scope.rpcForm1095CSubscriber.aprlowcostmonthprem= ($scope.form.aprlowcostmonthprem !== undefined) ? $scope.form.aprlowcostmonthprem : '';
        $scope.rpcForm1095CSubscriber.aprsafeharborcode= ($scope.form.aprsafeharborcode !== undefined) ? $scope.form.aprsafeharborcode : '';
        $scope.rpcForm1095CSubscriber.mayoffercovercode= ($scope.form.mayoffercovercode !== undefined) ? $scope.form.mayoffercovercode : '';
        $scope.rpcForm1095CSubscriber.maylowcostmonthprem= ($scope.form.maylowcostmonthprem !== undefined) ? $scope.form.maylowcostmonthprem : '';
        $scope.rpcForm1095CSubscriber.maysafeharborcode= ($scope.form.maysafeharborcode !== undefined) ? $scope.form.maysafeharborcode : '';
        $scope.rpcForm1095CSubscriber.junoffercovercode= ($scope.form.junoffercovercode !== undefined) ? $scope.form.junoffercovercode : '';
        $scope.rpcForm1095CSubscriber.junlowcostmonthprem= ($scope.form.junlowcostmonthprem !== undefined) ? $scope.form.junlowcostmonthprem : '';
        $scope.rpcForm1095CSubscriber.junsafeharborcode= ($scope.form.junsafeharborcode !== undefined) ? $scope.form.junsafeharborcode : '';
        $scope.rpcForm1095CSubscriber.juloffercovercode= ($scope.form.juloffercovercode !== undefined) ? $scope.form.juloffercovercode : '';
        $scope.rpcForm1095CSubscriber.jullowcostmonthprem= ($scope.form.jullowcostmonthprem !== undefined) ? $scope.form.jullowcostmonthprem : '';
        $scope.rpcForm1095CSubscriber.julsafeharborcode= ($scope.form.julsafeharborcode !== undefined) ? $scope.form.julsafeharborcode : '';
        $scope.rpcForm1095CSubscriber.augoffercovercode= ($scope.form.augoffercovercode !== undefined) ? $scope.form.augoffercovercode : '';
        $scope.rpcForm1095CSubscriber.auglowcostmonthprem= ($scope.form.auglowcostmonthprem !== undefined) ? $scope.form.auglowcostmonthprem : '';
        $scope.rpcForm1095CSubscriber.augsafeharborcode= ($scope.form.augsafeharborcode !== undefined) ? $scope.form.augsafeharborcode : '';
        $scope.rpcForm1095CSubscriber.sepoffercovercode= ($scope.form.sepoffercovercode !== undefined) ? $scope.form.sepoffercovercode : '';
        $scope.rpcForm1095CSubscriber.seplowcostmonthprem= ($scope.form.seplowcostmonthprem !== undefined) ? $scope.form.seplowcostmonthprem : '';
        $scope.rpcForm1095CSubscriber.sepsafeharborcode= ($scope.form.sepsafeharborcode !== undefined) ? $scope.form.sepsafeharborcode : '';
        $scope.rpcForm1095CSubscriber.octoffercovercode= ($scope.form.octoffercovercode !== undefined) ? $scope.form.octoffercovercode : '';
        $scope.rpcForm1095CSubscriber.octlowcostmonthprem=($scope.form.octlowcostmonthprem !== undefined) ? $scope.form.octlowcostmonthprem : '';
        $scope.rpcForm1095CSubscriber.octsafeharborcode= ($scope.form.octsafeharborcode !== undefined) ? $scope.form.octsafeharborcode : '';
        $scope.rpcForm1095CSubscriber.novoffercovercode= ($scope.form.novoffercovercode !== undefined) ? $scope.form.novoffercovercode : '';
        $scope.rpcForm1095CSubscriber.novlowcostmonthprem= ($scope.form.novlowcostmonthprem !== undefined) ? $scope.form.novlowcostmonthprem : '';
        $scope.rpcForm1095CSubscriber.novsafeharborcode= ($scope.form.novsafeharborcode !== undefined) ? $scope.form.novsafeharborcode : '';
        $scope.rpcForm1095CSubscriber.decoffercovercode= ($scope.form.decoffercovercode !== undefined) ? $scope.form.decoffercovercode : '';
        $scope.rpcForm1095CSubscriber.declowcostmonthprem= ($scope.form.declowcostmonthprem !== undefined) ? $scope.form.declowcostmonthprem : '';
        $scope.rpcForm1095CSubscriber.decsafeharborcode= ($scope.form.decsafeharborcode !== undefined) ? $scope.form.decsafeharborcode : '';
      }
      else{
        $scope.form.offercovercode = ($scope.form.offercovercode !== undefined) ? $scope.form.offercovercode : '';
        $scope.form.lowcostmonthprem = ($scope.form.lowcostmonthprem !== undefined) ? $scope.form.lowcostmonthprem : '';
        $scope.form.safeharborcode = ($scope.form.safeharborcode !== undefined) ? $scope.form.safeharborcode : '';
        $scope.rpcForm1095CSubscriber.janoffercovercode= $scope.form.offercovercode;
        $scope.rpcForm1095CSubscriber.janlowcostmonthprem= $scope.form.lowcostmonthprem;
        $scope.rpcForm1095CSubscriber.jansafeharborcode= $scope.form.safeharborcode;
        $scope.rpcForm1095CSubscriber.feboffercovercode= $scope.form.offercovercode;
        $scope.rpcForm1095CSubscriber.feblowcostmonthprem= $scope.form.lowcostmonthprem;
        $scope.rpcForm1095CSubscriber.febsafeharborcode= $scope.form.safeharborcode;
        $scope.rpcForm1095CSubscriber.maroffercovercode= $scope.form.offercovercode;
        $scope.rpcForm1095CSubscriber.marlowcostmonthprem= $scope.form.lowcostmonthprem;
        $scope.rpcForm1095CSubscriber.marsafeharborcode= $scope.form.safeharborcode;
        $scope.rpcForm1095CSubscriber.aproffercovercode= $scope.form.offercovercode;
        $scope.rpcForm1095CSubscriber.aprlowcostmonthprem= $scope.form.lowcostmonthprem;
        $scope.rpcForm1095CSubscriber.aprsafeharborcode= $scope.form.safeharborcode;
        $scope.rpcForm1095CSubscriber.mayoffercovercode= $scope.form.offercovercode;
        $scope.rpcForm1095CSubscriber.maylowcostmonthprem= $scope.form.lowcostmonthprem;
        $scope.rpcForm1095CSubscriber.maysafeharborcode= $scope.form.safeharborcode;
        $scope.rpcForm1095CSubscriber.junoffercovercode= $scope.form.offercovercode;
        $scope.rpcForm1095CSubscriber.junlowcostmonthprem= $scope.form.lowcostmonthprem;
        $scope.rpcForm1095CSubscriber.junsafeharborcode= $scope.form.safeharborcode;
        $scope.rpcForm1095CSubscriber.juloffercovercode= $scope.form.offercovercode;
        $scope.rpcForm1095CSubscriber.jullowcostmonthprem= $scope.form.lowcostmonthprem;
        $scope.rpcForm1095CSubscriber.julsafeharborcode= $scope.form.safeharborcode;
        $scope.rpcForm1095CSubscriber.augoffercovercode= $scope.form.offercovercode;
        $scope.rpcForm1095CSubscriber.auglowcostmonthprem= $scope.form.lowcostmonthprem;
        $scope.rpcForm1095CSubscriber.augsafeharborcode= $scope.form.safeharborcode;
        $scope.rpcForm1095CSubscriber.sepoffercovercode= $scope.form.offercovercode;
        $scope.rpcForm1095CSubscriber.seplowcostmonthprem= $scope.form.lowcostmonthprem;
        $scope.rpcForm1095CSubscriber.sepsafeharborcode= $scope.form.safeharborcode;
        $scope.rpcForm1095CSubscriber.octoffercovercode= $scope.form.offercovercode;
        $scope.rpcForm1095CSubscriber.octlowcostmonthprem= $scope.form.lowcostmonthprem;
        $scope.rpcForm1095CSubscriber.octsafeharborcode= $scope.form.safeharborcode;
        $scope.rpcForm1095CSubscriber.novoffercovercode= $scope.form.offercovercode;
        $scope.rpcForm1095CSubscriber.novlowcostmonthprem= $scope.form.lowcostmonthprem;
        $scope.rpcForm1095CSubscriber.novsafeharborcode= $scope.form.safeharborcode;
        $scope.rpcForm1095CSubscriber.decoffercovercode= $scope.form.offercovercode;
        $scope.rpcForm1095CSubscriber.declowcostmonthprem= $scope.form.lowcostmonthprem;
        $scope.rpcForm1095CSubscriber.decsafeharborcode= $scope.form.safeharborcode;
      }
    };

    $scope.add1095CSubscriber = function(form){
      if($scope.validateMandatory()){
        return true;
      }
      if(!form.$valid) {
        $scope.incompleteMessage = FORM_MESSAGES.INCOMPLETE;
      }
      $scope.rpcForm1095CSubscriber.status = 'S';
      addPart1();
      addSubscriberMonthlyOffer();
      if($scope.taxyear >= 2020){
        addZipCodes();        
        $scope.rpcForm1095CSubscriber.empbirthdate = ($scope.form.empbirthdate !== undefined)? $scope.form.empbirthdate: '';
        $scope.rpcForm1095CSubscriber.planstartmonth = ($scope.form.planstartmonth !== undefined)? $scope.form.planstartmonth: '';
      }
      $scope.rpcForm1095CSubscriber = $scope.addCoverageMonths($scope.rpcForm1095CSubscriber);
      if(form){
        switch($scope.formAction){
          case 'add':
            save1095C();
          break;
          case 'edit':
            updateForm('1095C');
          break;
        }
      }
      else{
        $scope.validateFields();
      }
    };

    $scope.add1095BSubscriber = function(form, formAction){
      if(!form.$valid || !$scope.selectedItem) {
        $scope.incompleteMessage = FORM_MESSAGES.INCOMPLETE;
        return true;
      }
      $scope.rpcForm1095BSubscriber.tin = $scope.selectedItem.tin;
      $scope.rpcForm1095BSubscriber.accountno = $scope.selectedItem.accountno;
      $scope.rpcForm1095BSubscriber.ptin = $scope.form.ptin.ptin;
      $scope.rpcForm1095BSubscriber.employersponsor = ($scope.form.employersponsor) ? $scope.form.employersponsor.ptin : undefined;
      $scope.rpcForm1095BSubscriber.originofpolicy = $scope.form.originofpolicy;
      $scope.rpcForm1095BSubscriber.status = 'S';
      $scope.rpcForm1095BSubscriber = $scope.addCoverageMonths($scope.rpcForm1095BSubscriber);

      if(form){
        switch(formAction){
          case 'add':
            save1095B();
          break;
          case 'edit':
            updateForm('1095B');
          break;
        }
      }
      else{
        $scope.validateFields();
      }
    };

    $scope.evaluate = function(value1, value2){
      return LayoutService.selectedItemToUpperCase(value1, value2);
    };

    $(document).click(function(){
      $('.search-options-menu').hide('fast');
    });

    var save1095B = function(){
      FormService.save1095B($scope.rpcForm1095BSubscriber, $scope.validationFlagForm).then(
        function(data){
          if(data.result.DataBool){
            $rootScope.isRefresh = 'refreshForm';
            $scope.validationFlagForm = false;
            var subscriber = {
              formName: '1095-B',
              name: $scope.selectedItem.name,
              middlename: $scope.selectedItem.middlename,
              name2: $scope.selectedItem.name2,
              tin: $scope.selectedItem.tin,
              ptin: $scope.rpcForm1095BSubscriber.ptin,
              accountnoSub: $scope.selectedItem.accountno,
              originofpolicy: $scope.rpcForm1095BSubscriber.originofpolicy,
              employersponsor: $scope.rpcForm1095BSubscriber.employersponsor
            };
            if($scope.selectedItem.modrecno !== undefined){
              $rootScope.currentParticipant = $scope.selectedItem;
            }
            $mdDialog.hide();
            $mdDialog.show({
              templateUrl: 'app/views/form/modals/form1095BDependent.html',
              controller: 'FormDependentController',
              preserveScope: true,
              locals: {
                subscriber: subscriber,
                currentForm: undefined
              }
            });
          }
          else{
            enabledError(data.result);
          }
        },
        function(error){
          if(error.data.error.frontend_code === EXCEPTION.DUPLICATEDFORM){
            duplicateForm('1095B');
          }
          else{
            $scope.errorMessage = FORM_MESSAGES.ERRORSAVING1095BSUBS;
          }
        }
      );
    };

    var duplicateForm = function(templateUrl){
      $scope.templateFormName = templateUrl;
      $mdDialog.show({
        templateUrl: 'app/views/form/modals/duplicateForm.html',
        preserveScope: true,
        scope: $scope
      });
    };

    var getTemplate = function(formName, statusForm){
      var base = 'app/views/form/modals/form';
      var status = (statusForm === undefined)? '': statusForm;
      if(formName === '1095C' && statusForm !== 'Dependent' && $scope.taxyear >= 2020){
        return base + formName + status + '-ty-2020.html';
      }
      return base + formName + status + '.html';
    };

    $scope.reOpenModal = function(){
      $mdDialog.show({
        templateUrl: getTemplate($scope.templateFormName),
        preserveScope: true,
        onComplete: function(){
          switchModal();
          selectedCombo();
        },
        scope: $scope
      });
    };

    $scope.reprintCancel = function(){
      $mdDialog.show({
        templateUrl: getTemplate($scope.templateFormName),
        preserveScope: true,
        onComplete: function(){
          switchModal();
        },
        scope: $scope
      });
    };

    var switchModal = function(){
      switch($scope.templateFormName){
        case '1095B':
          $scope.form1095B.$setDirty();
        break;
        case '1095C':
          $scope.form1095C.$setDirty();
        break;
      }
    };

    $scope.reprintYes = function(){
      $mdDialog.hide();
      $scope.form.stmtrun = 0;
      updateFormAfterReprint();
    };

    $scope.reprintNot = function(){
      $mdDialog.hide();
      updateFormAfterReprint();
    };

    var updateForm = function(templateFormName){
      $scope.templateFormName = templateFormName;
      if($scope.form.stmtrun !== undefined && !$scope.validationFlagForm){
        $mdDialog.show({
          templateUrl: 'app/views/form/modals/printCorrection.html',
          preserveScope: true,
          scope: $scope
        });
      }
      else{
        updateFormAfterReprint();
      };
    };

    var updateFormAfterReprint = function(){
      switch($scope.templateFormName){
        case '1095B':
          update1095B();
        break;
        case '1095C':
          update1095C();
        break;
      }
    };

    var update1095B = function(){
      $scope.rpcForm1095BSubscriber.seghash = $scope.form.seghash;
      $scope.rpcForm1095BSubscriber.datemodified = $scope.form.datemodified;
      $scope.rpcForm1095BSubscriber.modid = $scope.form.modid;
      $scope.rpcForm1095BSubscriber.recno = $scope.form.recno;
      $scope.rpcForm1095BSubscriber.modlevel = $scope.form.modlevel;
      $scope.rpcForm1095BSubscriber.recordversion = $scope.form.recordversion;
      $scope.rpcForm1095BSubscriber.taxyear = $scope.form.taxyear;
      $scope.rpcForm1095BSubscriber.stmtrun = UtilsService.checkAvoidNullification($scope.form.stmtrun);
      $scope.rpcForm1095BSubscriber.xmitrun = UtilsService.checkAvoidNullification($scope.form.xmitrun);
      $scope.rpcForm1095BSubscriber.groupstatus = $scope.form.groupstatus;
      FormService.update1095B($scope.rpcForm1095BSubscriber, $scope.validationFlagForm).then(
        function(data){
          if(data.result.DataBool){
            $rootScope.isRefresh = 'refreshForm';
            $scope.validationFlagForm = false;
            $mdDialog.hide();
            $mdDialog.show({
              controller: [
                '$scope',
                '$mdDialog',
                function($scope, $mdDialog){
                  $scope.formName = '1095-B Subscriber';
                  $scope.description = 'Updated';
                  $scope.closeModal = function(){
                    ShortcutsService.enableBackSpaceDefault();
                    $mdDialog.hide();
                  };
                }
              ],
              templateUrl: 'app/views/form/modals/editSubscriberSuccessMessage.html'
            });
          }
          else{
            $scope.reprintCancel();
            enabledError(data.result);
          }
        },
        function(error){
          if(error.data.error.frontend_code === 'RECORDMODIFIED'){
            $scope.errorMessage = error.data.error.frontend_message;
          }
          else if(error.data.error.frontend_code === EXCEPTION.DUPLICATEDFORM){
            duplicateForm('1095B');
          }
          else{
            $scope.errorMessage = FORM_MESSAGES.ERRORUPDATING1095BSUBS;
          }
        }
      );
    };

    var save1095C = function(){
      $scope.rpcForm1095CSubscriber.xmitrun = UtilsService.checkAvoidNullification($scope.form.xmitrun);
      FormService.save1095C($scope.rpcForm1095CSubscriber, $scope.validationFlagForm).then(
        function(data){
          if(data.result.DataBool){
            $rootScope.isRefresh = 'refreshForm';
            $scope.validationFlagForm = false;
            
            if($scope.selectedItem.modrecno !== undefined){
              $rootScope.currentParticipant = $scope.selectedItem;
            }
            $mdDialog.hide();
            $mdDialog.show({
              scope: $scope,
              preserveScope: true,
              controller: [
                '$scope',
                '$rootScope',
                '$mdDialog',
                function($scope, $rootScope, $mdDialog, error){
                  $scope.closeModal = function(){
                    $mdDialog.hide();
                  };
                }
              ],
              templateUrl: 'app/views/form/modals/form1095CSelectDependent.html',
            });
          }
          else{
            enabledError(data.result);
          }
        },
        function(error){
          if(error.data.error.frontend_code === EXCEPTION.DUPLICATEDFORM){
            duplicateForm('1095C');
          }
          else{
            $scope.errorMessage = FORM_MESSAGES.ERRORSAVING1095CSUBS;
          }
        }
      );
    };

    $scope.open1095CDependent = function() {
      var subscriber = {
        formName: '1095-C',
        name: $scope.selectedItem.name,
        tin: $scope.selectedItem.tin,
        ptin: $scope.rpcForm1095CSubscriber.ptin,
        accountnoSub: $scope.selectedItem.accountno,
        description: $scope.selectedItem.description
      };
      $mdDialog.show({
        templateUrl: getTemplate('1095C','Dependent'),
        controller: 'FormDependentController',
        preserveScope: true,
        locals: {
          subscriber: subscriber,
          currentForm: undefined
        }
      })
    }

    var update1095C = function(){
      $scope.rpcForm1095CSubscriber.seghash = $scope.form.seghash;
      $scope.rpcForm1095CSubscriber.datemodified = $scope.form.datemodified;
      $scope.rpcForm1095CSubscriber.modid = $scope.form.modid;
      $scope.rpcForm1095CSubscriber.recno = $scope.form.recno;
      $scope.rpcForm1095CSubscriber.modlevel = $scope.form.modlevel;
      $scope.rpcForm1095CSubscriber.recordversion = $scope.form.recordversion;
      $scope.rpcForm1095CSubscriber.taxyear = $scope.form.taxyear;
      $scope.rpcForm1095CSubscriber.stmtrun = ($scope.form.stmtrun !== undefined) ? $scope.form.stmtrun : -2147483648;
      $scope.rpcForm1095CSubscriber.groupstatus = $scope.form.groupstatus;
      FormService.update1095C($scope.rpcForm1095CSubscriber, $scope.validationFlagForm).then(
        function(data){
          if(data.result.DataBool){
            $rootScope.isRefresh = 'refreshForm';
            $scope.validationFlagForm = false;
            $mdDialog.hide();
            $mdDialog.show({
              controller: [
                '$scope',
                '$mdDialog',
                function($scope, $mdDialog){
                  $scope.formName = '1095-C Subscriber';
                  $scope.description = 'Updated';
                  $scope.closeModal = function(){
                    ShortcutsService.enableBackSpaceDefault();
                    $mdDialog.hide();
                  };
                }
              ],
              templateUrl: 'app/views/form/modals/editSubscriberSuccessMessage.html'
            });
          }
          else{
            $scope.reprintCancel();
            enabledError(data.result);
          }
        },
        function(error){
          if(error.data.error.frontend_code === 'RECORDMODIFIED'){
            $scope.errorMessage = error.data.error.frontend_message;
          }
          else if(error.data.error.frontend_code === EXCEPTION.DUPLICATEDFORM){
            duplicateForm('1095C');
          }
          else{
            $scope.errorMessage = FORM_MESSAGES.ERRORUPDATING1095CSUBS;
          }
        }
      );
    };

    var enabledError = function(error){
      $scope.validationFlagForm = true;
      $scope.validationMessage = UtilsService.errorMessageValidationForString(error.ErrorMessage);
      $scope.validationsBE = true;
    };
    $scope.isDisabledSearchAutocomplete = $scope.formAction === 'add' ? false : true;
    var selectedCombo = function(){
      $timeout(
        function(){
          if($scope.form.originofpolicy !== undefined){
            LayoutService.setSelectBoxChange('#originofpolicy-selected', $scope.form.originofpolicy, '#originofpolicy-label');
          }
          if($scope.form.employersponsor !== undefined){
            if($scope.form.employersponsor.ptin){
              LayoutService.setSelectBoxChange('#employersponsor-selected', $scope.form.employersponsor.ptin, '#employersponsor-label');
            }
            else{
              LayoutService.setSelectBoxChange('#employersponsor-selected', $scope.form.employersponsor, '#employersponsor-label');
            }
          }
          if($scope.form.ptin.ptin !== undefined){
            LayoutService.setSelectBoxChange('#issuer-selected', $scope.form.ptin.ptin, '#issuer-label');
          }
          if(!isUndefined()){
            LayoutService.setSelectBoxChange('#employer-selected', $scope.form.ptin, '#employer-label');
          }
        }
      );
    };
    var isUndefined = function(){
      return $scope.form.ptin === undefined;
    };
    selectedCombo();
  }
]);
